<script setup>
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import SettingsLayout from '../SettingsLayout.vue';
import BaseSettingsHeader from '../components/BaseSettingsHeader.vue';
import RoleForm from './RoleForm.vue';

const { t } = useI18n();
const store = useStore();
const router = useRouter();

const uiFlags = useMapGetter('customRoles/getUIFlags');
const currentAccountId = useMapGetter('getCurrentAccountId');

const goToList = () => {
  router.push({
    name: 'custom_roles_list',
    params: { accountId: currentAccountId.value },
  });
};

const onSubmit = async payload => {
  try {
    await store.dispatch('customRoles/create', payload);
    useAlert(t('SETTINGS.CUSTOM_ROLES.ADD.API.SUCCESS_MESSAGE'));
    goToList();
  } catch (error) {
    useAlert(
      error?.message || t('SETTINGS.CUSTOM_ROLES.ADD.API.ERROR_MESSAGE')
    );
  }
};
</script>

<template>
  <SettingsLayout>
    <template #header>
      <BaseSettingsHeader
        :title="t('SETTINGS.CUSTOM_ROLES.ADD.TITLE')"
        :description="t('SETTINGS.CUSTOM_ROLES.ADD.DESC')"
      />
    </template>
    <template #body>
      <div class="max-w-3xl">
        <RoleForm
          :submit-label="t('SETTINGS.CUSTOM_ROLES.ADD.SUBMIT')"
          :is-submitting="uiFlags.isCreating"
          @submit="onSubmit"
          @cancel="goToList"
        />
      </div>
    </template>
  </SettingsLayout>
</template>
